import Clickable from 'components/Common/Clickable'
import { rem } from 'polished'
import type { HTMLAttributes, MouseEventHandler, ReactElement } from 'react'
import { forwardRef } from 'react'
import styled from 'styled-components'
import _StepIcon from './_StepIcon'
import _StepLabel from './_StepLabel'
import Caption from '../Typography/Caption'

const Container = styled(Clickable)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${rem(4)};
  height: ${rem(32)};
  padding: 0 ${rem(4)};
  flex-shrink: 0;
`

interface Props extends HTMLAttributes<HTMLButtonElement> {
  number: number
  state: 'active' | 'inactive' | 'completed'
  label: string | ReactElement
  /**
   * When true, the completed state becomes clickable.
   * `onClick` will become necessary.
   */
  interactive?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
  sublabel?: string | ReactElement
}

const Step = forwardRef<HTMLButtonElement, Props>(function Step(props, ref) {
  const {
    number,
    state,
    label,
    interactive,
    onClick,
    sublabel,
    ...rest
  } = props

  const canBeInteractive = interactive && state === 'completed'

  return <Container
    {...rest}
    ref={ref}
    as={!canBeInteractive ? 'div' : undefined}
    onClick={canBeInteractive ? onClick : undefined}
  >
    <_StepIcon number={number} state={state} interactive={canBeInteractive} />

    <div>
      <_StepLabel state={state} underline={canBeInteractive}>{label}</_StepLabel>
      {sublabel && <Caption variant="medium" colour="neutral-three">{sublabel}</Caption>}
    </div>
  </Container>
})

export default Step
